"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENGINE_VALUE_INVALID = exports.USER_CONSENT_INITIAL = exports.USER_CONSENT_NOT_UPDATED = exports.USER_CONSENT_UPDATED = exports.IMPRESSIONS_TRACKER_SUCCESS = exports.EVENTS_TRACKER_SUCCESS = exports.SYNC_STOP_POLLING = exports.SYNC_CONTINUE_POLLING = exports.SYNC_START_POLLING = exports.SUBMITTERS_PUSH = exports.SUBMITTERS_PUSH_FULL_QUEUE = exports.STREAMING_DISCONNECTING = exports.STREAMING_DISABLED = exports.STREAMING_CONNECTING = exports.STREAMING_RECONNECT = exports.STREAMING_REFRESH_TOKEN = exports.SYNC_SPLITS_FETCH_RETRY = exports.POLLING_STOP = exports.POLLING_START = exports.POLLING_SMART_PAUSING = exports.NEW_FACTORY = exports.NEW_SHARED_CLIENT = exports.IMPRESSION_QUEUEING = exports.IMPRESSION = exports.CLIENT_READY = exports.CLIENT_READY_FROM_CACHE = exports.ENGINE_MATCHER_RESULT = exports.SETTINGS_SPLITS_FILTER = exports.SYNC_TASK_STOP = exports.SYNC_TASK_EXECUTE = exports.SYNC_TASK_START = exports.STREAMING_NEW_MESSAGE = exports.SYNC_SPLITS_SEGMENTS = exports.SYNC_SPLITS_REMOVED = exports.SYNC_SPLITS_NEW = exports.SYNC_SPLITS_FETCH = exports.SYNC_OFFLINE_DATA = exports.RETRIEVE_MANAGER = exports.RETRIEVE_CLIENT_EXISTING = exports.RETRIEVE_CLIENT_DEFAULT = exports.CLEANUP_DEREGISTERING = exports.CLEANUP_REGISTERING = exports.ENGINE_SANITIZE = exports.ENGINE_VALUE = exports.ENGINE_MATCHER_DEPENDENCY_PRE = exports.ENGINE_MATCHER_DEPENDENCY = exports.ENGINE_BUCKET = exports.ENGINE_COMBINER_IFELSEIF_NO_TREATMENT = exports.ENGINE_COMBINER_IFELSEIF = exports.ENGINE_COMBINER_AND = void 0;
exports.ERROR_INVALID_CONFIG_PARAM = exports.ERROR_EMPTY_ARRAY = exports.ERROR_EMPTY = exports.ERROR_INVALID = exports.ERROR_INVALID_KEY_OBJECT = exports.ERROR_TOO_LONG = exports.ERROR_NULL = exports.ERROR_CLIENT_DESTROYED = exports.ERROR_NOT_FINITE = exports.ERROR_SIZE_EXCEEDED = exports.ERROR_NOT_PLAIN_OBJECT = exports.ERROR_EVENT_TYPE_FORMAT = exports.ERROR_EVENTS_TRACKER = exports.ERROR_IMPRESSIONS_LISTENER = exports.ERROR_IMPRESSIONS_TRACKER = exports.ERROR_STREAMING_AUTH = exports.ERROR_STREAMING_SSE = exports.ERROR_SYNC_OFFLINE_LOADING = exports.ERROR_CLIENT_CANNOT_GET_READY = exports.ERROR_CLIENT_LISTENER = exports.ERROR_LOGLEVEL_INVALID = exports.ERROR_ENGINE_COMBINER_IFELSEIF = exports.WARN_FLAGSET_WITHOUT_FLAGS = exports.WARN_FLAGSET_NOT_CONFIGURED = exports.WARN_LOWERCASE_FLAGSET = exports.WARN_INVALID_FLAGSET = exports.STREAMING_PARSING_SPLIT_UPDATE = exports.STREAMING_PARSING_MY_SEGMENTS_UPDATE_V2 = exports.WARN_SDK_KEY = exports.WARN_SPLITS_FILTER_EMPTY = exports.WARN_SPLITS_FILTER_INVALID = exports.WARN_SPLITS_FILTER_IGNORED = exports.WARN_INTEGRATION_INVALID = exports.WARN_NOT_EXISTENT_TT = exports.WARN_LOWERCASE_TRAFFIC_TYPE = exports.WARN_NOT_EXISTENT_SPLIT = exports.WARN_TRIMMING = exports.WARN_CONVERTING = exports.WARN_TRIMMING_PROPERTIES = exports.WARN_SETTING_NULL = exports.SUBMITTERS_PUSH_RETRY = exports.SUBMITTERS_PUSH_FAILS = exports.STREAMING_FALLBACK = exports.STREAMING_PARSING_MESSAGE_FAILS = exports.STREAMING_PARSING_ERROR_FAILS = exports.SYNC_SPLITS_FETCH_FAILS = exports.SYNC_MYSEGMENTS_FETCH_RETRY = exports.CLIENT_NOT_READY = exports.CLIENT_NO_LISTENER = exports.ENGINE_VALUE_NO_ATTRIBUTES = void 0;
exports.LOG_PREFIX_CLEANUP = exports.LOG_PREFIX_UNIQUE_KEYS_TRACKER = exports.LOG_PREFIX_EVENTS_TRACKER = exports.LOG_PREFIX_IMPRESSIONS_TRACKER = exports.LOG_PREFIX_SYNC_SUBMITTERS = exports.LOG_PREFIX_SYNC_POLLING = exports.LOG_PREFIX_SYNC_MYSEGMENTS = exports.LOG_PREFIX_SYNC_SEGMENTS = exports.LOG_PREFIX_SYNC_SPLITS = exports.LOG_PREFIX_SYNC_STREAMING = exports.LOG_PREFIX_SYNC_OFFLINE = exports.LOG_PREFIX_SYNC_MANAGER = exports.LOG_PREFIX_SYNC = exports.LOG_PREFIX_ENGINE_VALUE = exports.LOG_PREFIX_ENGINE_MATCHER = exports.LOG_PREFIX_ENGINE_COMBINER = exports.LOG_PREFIX_ENGINE = exports.LOG_PREFIX_CLIENT_INSTANTIATION = exports.LOG_PREFIX_INSTANTIATION = exports.LOG_PREFIX_SETTINGS = exports.ENGINE_MATCHER_ERROR = exports.ERROR_SETS_FILTER_EXCLUSIVE = exports.ERROR_TOO_MANY_SETS = exports.ERROR_MIN_CONFIG_PARAM = exports.ERROR_NOT_BOOLEAN = exports.ERROR_STORAGE_INVALID = exports.ERROR_LOCALHOST_MODULE_REQUIRED = exports.ERROR_HTTP = void 0;
/**
 * Message codes used to trim string log messages from commons and client-side API modules,
 * in order to reduce the minimal SDK size for Browser and eventually other client-side environments.
 *
 * Modules related to the server-side API (e.g., segmentsSyncTask), platform-specific components (e.g., signal listeners)
 * and pluggable components (e.g., pluggable integrations & storages) can use the logger with string literals.
 */
exports.ENGINE_COMBINER_AND = 0;
exports.ENGINE_COMBINER_IFELSEIF = 1;
exports.ENGINE_COMBINER_IFELSEIF_NO_TREATMENT = 2;
exports.ENGINE_BUCKET = 3;
exports.ENGINE_MATCHER_DEPENDENCY = 10;
exports.ENGINE_MATCHER_DEPENDENCY_PRE = 11;
exports.ENGINE_VALUE = 23;
exports.ENGINE_SANITIZE = 24;
exports.CLEANUP_REGISTERING = 25;
exports.CLEANUP_DEREGISTERING = 26;
exports.RETRIEVE_CLIENT_DEFAULT = 27;
exports.RETRIEVE_CLIENT_EXISTING = 28;
exports.RETRIEVE_MANAGER = 29;
exports.SYNC_OFFLINE_DATA = 30;
exports.SYNC_SPLITS_FETCH = 31;
exports.SYNC_SPLITS_NEW = 32;
exports.SYNC_SPLITS_REMOVED = 33;
exports.SYNC_SPLITS_SEGMENTS = 34;
exports.STREAMING_NEW_MESSAGE = 35;
exports.SYNC_TASK_START = 36;
exports.SYNC_TASK_EXECUTE = 37;
exports.SYNC_TASK_STOP = 38;
exports.SETTINGS_SPLITS_FILTER = 39;
exports.ENGINE_MATCHER_RESULT = 40;
exports.CLIENT_READY_FROM_CACHE = 100;
exports.CLIENT_READY = 101;
exports.IMPRESSION = 102;
exports.IMPRESSION_QUEUEING = 103;
exports.NEW_SHARED_CLIENT = 104;
exports.NEW_FACTORY = 105;
exports.POLLING_SMART_PAUSING = 106;
exports.POLLING_START = 107;
exports.POLLING_STOP = 108;
exports.SYNC_SPLITS_FETCH_RETRY = 109;
exports.STREAMING_REFRESH_TOKEN = 110;
exports.STREAMING_RECONNECT = 111;
exports.STREAMING_CONNECTING = 112;
exports.STREAMING_DISABLED = 113;
exports.STREAMING_DISCONNECTING = 114;
exports.SUBMITTERS_PUSH_FULL_QUEUE = 115;
exports.SUBMITTERS_PUSH = 116;
exports.SYNC_START_POLLING = 117;
exports.SYNC_CONTINUE_POLLING = 118;
exports.SYNC_STOP_POLLING = 119;
exports.EVENTS_TRACKER_SUCCESS = 120;
exports.IMPRESSIONS_TRACKER_SUCCESS = 121;
exports.USER_CONSENT_UPDATED = 122;
exports.USER_CONSENT_NOT_UPDATED = 123;
exports.USER_CONSENT_INITIAL = 124;
exports.ENGINE_VALUE_INVALID = 200;
exports.ENGINE_VALUE_NO_ATTRIBUTES = 201;
exports.CLIENT_NO_LISTENER = 202;
exports.CLIENT_NOT_READY = 203;
exports.SYNC_MYSEGMENTS_FETCH_RETRY = 204;
exports.SYNC_SPLITS_FETCH_FAILS = 205;
exports.STREAMING_PARSING_ERROR_FAILS = 206;
exports.STREAMING_PARSING_MESSAGE_FAILS = 207;
exports.STREAMING_FALLBACK = 208;
exports.SUBMITTERS_PUSH_FAILS = 209;
exports.SUBMITTERS_PUSH_RETRY = 210;
exports.WARN_SETTING_NULL = 211;
exports.WARN_TRIMMING_PROPERTIES = 212;
exports.WARN_CONVERTING = 213;
exports.WARN_TRIMMING = 214;
exports.WARN_NOT_EXISTENT_SPLIT = 215;
exports.WARN_LOWERCASE_TRAFFIC_TYPE = 216;
exports.WARN_NOT_EXISTENT_TT = 217;
exports.WARN_INTEGRATION_INVALID = 218;
exports.WARN_SPLITS_FILTER_IGNORED = 219;
exports.WARN_SPLITS_FILTER_INVALID = 220;
exports.WARN_SPLITS_FILTER_EMPTY = 221;
exports.WARN_SDK_KEY = 222;
exports.STREAMING_PARSING_MY_SEGMENTS_UPDATE_V2 = 223;
exports.STREAMING_PARSING_SPLIT_UPDATE = 224;
exports.WARN_INVALID_FLAGSET = 225;
exports.WARN_LOWERCASE_FLAGSET = 226;
exports.WARN_FLAGSET_NOT_CONFIGURED = 227;
exports.WARN_FLAGSET_WITHOUT_FLAGS = 228;
exports.ERROR_ENGINE_COMBINER_IFELSEIF = 300;
exports.ERROR_LOGLEVEL_INVALID = 301;
exports.ERROR_CLIENT_LISTENER = 302;
exports.ERROR_CLIENT_CANNOT_GET_READY = 303;
exports.ERROR_SYNC_OFFLINE_LOADING = 304;
exports.ERROR_STREAMING_SSE = 305;
exports.ERROR_STREAMING_AUTH = 306;
exports.ERROR_IMPRESSIONS_TRACKER = 307;
exports.ERROR_IMPRESSIONS_LISTENER = 308;
exports.ERROR_EVENTS_TRACKER = 309;
exports.ERROR_EVENT_TYPE_FORMAT = 310;
exports.ERROR_NOT_PLAIN_OBJECT = 311;
exports.ERROR_SIZE_EXCEEDED = 312;
exports.ERROR_NOT_FINITE = 313;
exports.ERROR_CLIENT_DESTROYED = 314;
exports.ERROR_NULL = 315;
exports.ERROR_TOO_LONG = 316;
exports.ERROR_INVALID_KEY_OBJECT = 317;
exports.ERROR_INVALID = 318;
exports.ERROR_EMPTY = 319;
exports.ERROR_EMPTY_ARRAY = 320;
exports.ERROR_INVALID_CONFIG_PARAM = 321;
exports.ERROR_HTTP = 322;
exports.ERROR_LOCALHOST_MODULE_REQUIRED = 323;
exports.ERROR_STORAGE_INVALID = 324;
exports.ERROR_NOT_BOOLEAN = 325;
exports.ERROR_MIN_CONFIG_PARAM = 326;
exports.ERROR_TOO_MANY_SETS = 327;
exports.ERROR_SETS_FILTER_EXCLUSIVE = 328;
exports.ENGINE_MATCHER_ERROR = 329;
// Log prefixes (a.k.a. tags or categories)
exports.LOG_PREFIX_SETTINGS = 'settings';
exports.LOG_PREFIX_INSTANTIATION = 'Factory instantiation';
exports.LOG_PREFIX_CLIENT_INSTANTIATION = 'Client instantiation';
exports.LOG_PREFIX_ENGINE = 'engine';
exports.LOG_PREFIX_ENGINE_COMBINER = exports.LOG_PREFIX_ENGINE + ':combiner: ';
exports.LOG_PREFIX_ENGINE_MATCHER = exports.LOG_PREFIX_ENGINE + ':matcher: ';
exports.LOG_PREFIX_ENGINE_VALUE = exports.LOG_PREFIX_ENGINE + ':value: ';
exports.LOG_PREFIX_SYNC = 'sync';
exports.LOG_PREFIX_SYNC_MANAGER = exports.LOG_PREFIX_SYNC + ':sync-manager: ';
exports.LOG_PREFIX_SYNC_OFFLINE = exports.LOG_PREFIX_SYNC + ':offline: ';
exports.LOG_PREFIX_SYNC_STREAMING = exports.LOG_PREFIX_SYNC + ':streaming: ';
exports.LOG_PREFIX_SYNC_SPLITS = exports.LOG_PREFIX_SYNC + ':featureflag-changes: ';
exports.LOG_PREFIX_SYNC_SEGMENTS = exports.LOG_PREFIX_SYNC + ':segment-changes: ';
exports.LOG_PREFIX_SYNC_MYSEGMENTS = exports.LOG_PREFIX_SYNC + ':my-segments: ';
exports.LOG_PREFIX_SYNC_POLLING = exports.LOG_PREFIX_SYNC + ':polling-manager: ';
exports.LOG_PREFIX_SYNC_SUBMITTERS = exports.LOG_PREFIX_SYNC + ':submitter: ';
exports.LOG_PREFIX_IMPRESSIONS_TRACKER = 'impressions-tracker: ';
exports.LOG_PREFIX_EVENTS_TRACKER = 'events-tracker: ';
exports.LOG_PREFIX_UNIQUE_KEYS_TRACKER = 'unique-keys-tracker: ';
exports.LOG_PREFIX_CLEANUP = 'cleanup: ';
